"use strict";

function getRedirectParam(path) {
	if (typeof path === "string" && path.length > 0) {
		if (path.charAt(0) === "/") {
			path = path.substr(1);
		}
		return encodeURIComponent(path);
	}
}

function employeeAuthHook(state, SessionStore, Handler) {
	if (state.routeParams.needsEmployee) {
		if (!SessionStore.loggedIn() || !SessionStore.isEmployee()) {
			if (console && console.warn) {
				console.warn("Not an employee -- redirecting to login...");
			}
			// Redirect to login
			Handler.transitionTo("/login/" + getRedirectParam(state.path));
			return { checkNext: false, didRedirect: true };
		}
	}
	return { checkNext: true, didRedirect: false };
}

module.exports = [employeeAuthHook];
